import Phaser from "phaser";
import { Colors } from "../consts/Colors.js";

export default class NavTitre extends Phaser.GameObjects.Container {
  constructor(scene, x, y, missionNumber, title, ratio = 1) {
    super(scene, x, y);

    this.hiddenY = y - 100;
    this.visibleY = y;
    this.y = this.hiddenY;

    const paddingX = 4 * ratio;
    const paddingY = 3 * ratio;
    const spacing = 4 * ratio;

    // === TEXT ===
    this.titleText = scene.add
      .text(0, 0, title?.toUpperCase(), {
        fontSize: `${11 * ratio}px`,
        fontFamily: "WWF",
        color: Colors.Text.DarkBlue,
      })
      .setOrigin(0, 0.5);

    // === BADGE ===
    this.badgeCircle = scene.add.image(0, 0, "rond-bleu").setOrigin(0.5);
    this.badgeNumber = scene.add
      .text(0, 0, missionNumber.toString(), {
        fontSize: `${11 * ratio}px`,
        fontFamily: "Binx",
        color: Colors.Text.White,
      })
      .setOrigin(0.5);

    // Position du texte par rapport au cercle
    const contentHeight = Math.max(
      this.badgeCircle.height,
      this.titleText.height
    );
    const contentWidth =
      this.badgeCircle.width + spacing + this.titleText.width;

    this.titleBack = scene.add
      .rexRoundRectangle(
        0,
        0,
        contentWidth + paddingX * 2,
        contentHeight + paddingY * 2,
        0,
        0xffffff
      )
      .setOrigin(0.5);

    // Positionner les éléments à l’intérieur
    const startX = -contentWidth / 2;
    this.badgeCircle.x = startX + 10;
    this.badgeCircle.y = 0;

    this.badgeNumber.x = startX + 10;
    this.badgeNumber.y = 1; // léger ajustement visuel

    this.titleText.x =
      this.badgeCircle.x + this.badgeCircle.width / 2 + spacing;
    this.titleText.y = 0;

    // Tout ajouter au container
    this.add([
      this.titleBack,
      this.badgeCircle,
      this.badgeNumber,
      this.titleText,
    ]);

    scene.add.existing(this);
  }

  showWithAnimation(duration = 500, delay = 0, paddingY = 3 * 3 * 2.8) {
    this.scene.tweens.add({
      targets: this,
      y: this.visibleY + paddingY,
      ease: "Cubic.easeOut",
      duration,
      delay,
    });
  }
}
